import React from 'react'
import { Button } from 'antd'
import {  Truck } from 'lucide-react'
import type { LineItem } from '../../types/ffe'
import { useFFEStore } from '../../store/ffeStore'

interface Props {
  item: LineItem
  className?: string
  disabled?: boolean
}

export const DeliveryButton: React.FC<Props> = ({
  item,
  className,
  disabled
}) => {
const setLineItemDetailsDrawerId = useFFEStore((state) => state.setLineItemDetailsDrawerId)

  return (
    <>
      <Button
        disabled={disabled}
        className={className}
        icon={<Truck className="h-4 w-4" />}
        onClick={() => setLineItemDetailsDrawerId(item.id)}
      >
        Delivery
      </Button>
    </>
  )
}
